import axios from "@/libs/axios.ts";
import { CookiesBody } from "@/types";

export const acceptCookiesReq = async (body: CookiesBody) => {
  return axios.post(`/cookies/accept-all`, body);
};
